import validator from 'validator';
import { isEmpty } from 'lodash/fp';
import { UserRole, UserType } from '@upstart/harmony/lib/constants';
import { DefaultPasswordLength } from '@upstart/harmony/lib/legos/constants/user';

export default (formData, errors) => {
  const { email, username, roles, password, type } = formData;

  if (email && !validator.isEmail(email)) {
    errors.email.addError('Please enter a valid email address');
  }
  if (username && !validator.isEmail(username)) {
    errors.username.addError('Please enter a valid email address');
  }
  if (isEmpty(roles)) {
    errors.roles.addError('Please select at least one role for this user');
  }
  if (
    roles?.includes(UserRole.SELF_DESKING) &&
    !roles?.includes(UserRole.USER)
  ) {
    errors.roles.addError('Self Desking users must also have the User role');
  }
  if (
    roles?.includes(UserRole.PRICING_MANAGEMENT) &&
    !roles?.includes(UserRole.DEALER_ADMIN)
  ) {
    errors.roles.addError(
      'Pricing Management users must also have the Dealer Admin role',
    );
  }
  if (
    roles?.includes(UserRole.DIGITAL_FINANCE_SALES_MANAGER) &&
    roles?.includes(UserRole.DIGITAL_FINANCE_FINANCE_MANAGER)
  ) {
    errors.roles.addError(
      'User should only have 1 of: Digital Finance Sales Manager, Digital Finance Finance Manager',
    );
  }
  if (password) {
    const minimumPasswordLength =
      type === UserType.EMPLOYEE
        ? DefaultPasswordLength.EMPLOYEE
        : DefaultPasswordLength.CLIENT;
    if (password.length < minimumPasswordLength) {
      errors.password.addError(
        `Minimum password length is ${minimumPasswordLength}`,
      );
    }
  }
  if (email.endsWith('@upstart.com') && type !== UserType.EMPLOYEE) {
    if (type) {
      errors.type.addError(
        'Users with an @upstart.com email must be an "employee" user',
      );
    } else {
      errors.email.addError('Dealer Users cannot use an @upstart.com email');
    }
  } else if (!email.endsWith('@upstart.com') && type === UserType.EMPLOYEE) {
    errors.type.addError(
      'Users with an external email must be an "advanced" user',
    );
  }

  return errors;
};
